import { Link } from "@tanstack/react-router";
import type { Author } from "~/utils/authors";

export interface BlogCardData {
  slug: string;
  title: string;
  description: string;
  date: string;
  featured_image: string;
  authors: Author[];
}

export function BlogCard({ post }: { post: BlogCardData }) {
  return (
    <li className="relative overflow-hidden rounded border border-[#DCDADA] bg-white transition-shadow hover:shadow-sm">
      {post.featured_image && (
        <div className="block aspect-[1200/630]">
          <img
            src={post.featured_image}
            alt={post.title}
            className="h-full w-full object-cover"
            loading="lazy"
          />
        </div>
      )}
      <div className="flex flex-col p-6">
        <h3 className="mb-3 font-body text-xl font-bold leading-tight text-charcoal">{post.title}</h3>
        <div className="mb-4 flex flex-wrap space-x-2 font-body text-sm text-gray-60">
          <time>
            {new Date(post.date).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </time>
          {post.authors.length > 0 && (
            <>
              <span>&middot;</span>
              <span>{post.authors[0].name}</span>
            </>
          )}
        </div>
        <div className="font-body text-sm text-gray-80">{post.description}</div>
        <Link
          to="/blog/$slug"
          params={{ slug: post.slug }}
          className="absolute inset-0"
          aria-label={post.title}
        />
      </div>
    </li>
  );
}
